import styled from 'styled-components';

const Container = styled.div`

`;
export default function FriendsList(){
    return (
        <Container></Container>
    );
}